const NavTabs = ({ tabs, activeTab, onTabChange }) => (
  <div className="bg-white border-b border-pw-border-variant px-6">
    <div className="flex gap-1 overflow-x-auto">
      {tabs.map(t => (
        <button key={t.id} onClick={() => onTabChange(t.id)}
          className={`flex items-center gap-2 px-4 py-3 border-b-2 font-medium text-sm transition-colors whitespace-nowrap ${
            activeTab === t.id
              ? 'border-pw-primary text-pw-primary'
              : 'border-transparent text-pw-text-variant hover:text-pw-text'
          }`}>
          {t.icon && <t.icon className="w-4 h-4" />}{t.label}
        </button>
      ))}
    </div>
  </div>
);
export default NavTabs;
